import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCollapse
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import { Text } from "../../../../components/SlateComponents";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class FaqList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true,
      show: null
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    axios
      .get(`${URL.api}helpdesk/faq/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            list: resp.data.data,
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    return (
      <div id="list" className="animated fadeIn">
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <Loading />
        ) : (
          <>
            {this.state.list.map(faq => (
              <CCard accentColor="primary">
                <CCardHeader
                  id="headingOne"
                  className={
                    this.state.show === faq.id ? "" : "rounded border-0"
                  }
                >
                  <CButton
                    block
                    className="text-left m-0 p-0"
                    onClick={() =>
                      this.setState(state => ({
                        show: state.show === faq.id ? null : faq.id
                      }))
                    }
                    style={{ boxShadow: "none" }}
                  >
                    <h4 className="m-0 p-0">
                      <Text>{faq.question}</Text>
                    </h4>
                  </CButton>
                </CCardHeader>
                <CCollapse show={this.state.show === faq.id}>
                  <CCardBody>
                    <Text>{faq.answer}</Text>
                  </CCardBody>
                </CCollapse>
              </CCard>
            ))}
          </>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FaqList);
